module.exports = __webpack_public_path__ + "static/media/m3.2eba7a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-cluster-icons/m3.png
// module id = 508
// module chunks = 0